import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, Input, message, Popconfirm } from "antd";
import { store } from '../../../app/store';
import { ServicesConfig } from "../../../service/servicesConfig";

const UserManager = () => {
  const [users, setUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [form] = Form.useForm();

  const baseURL = ServicesConfig.getBaseUrlV2()  + "/admin/user"; // Base URL para SGVMAP_USERController

  const getAuthorization = () => {
    const state = store.getState();
    return state.user.logged ? "Bearer " + state.user.token : ""
  }

  // Obtener la lista de usuarios
  const fetchUsers = async () => {
    try {
      const response = await fetch(`${baseURL}/list`, { headers: {
        'Authorization': getAuthorization()
      }}); // Suponemos que existe un endpoint para listar todos los usuarios
      if (!response.ok) throw new Error("Error al obtener los usuarios");
      const data = await response.json();
      setUsers(data);
    } catch (error) {
      message.error("Error al obtener la lista de usuarios");
      console.error(error);
    }
  };

  // Crear o actualizar un usuario
  const handleSaveUser = async (values) => {
    const method = editingUser ? "PUT" : "POST";
    const url = editingUser
      ? `${baseURL}/update/${editingUser.usr}`
      : `${baseURL}/create`;

    try {
      const response = await fetch(url, {
        method: method,
        headers: { "Content-Type": "application/json", 'Authorization': getAuthorization() },
        body: JSON.stringify(values),
      });
      if (!response.ok) throw new Error("Error al guardar el usuario");

      message.success(
        editingUser
          ? "Usuario actualizado correctamente"
          : "Usuario creado correctamente"
      );
      fetchUsers();
      setIsModalOpen(false);
      setEditingUser(null);
      form.resetFields();
    } catch (error) {
      message.error("Error al guardar el usuario");
      console.error(error);
    }
  };

  // Eliminar un usuario
  const handleDeleteUser = async (usr) => {
    try {
      const response = await fetch(`${baseURL}/delete/${usr}`, { 
        method: "DELETE", 
        headers: { 'Authorization': getAuthorization() } 
      });
      if (!response.ok) throw new Error("Error al eliminar el usuario");

      message.success("Usuario eliminado correctamente");
      fetchUsers();
    } catch (error) {
      message.error("Error al eliminar el usuario");
      console.error(error);
    }
  };

  // Abrir modal para edición
  const handleEdit = (user) => {
    setEditingUser(user);
    form.setFieldsValue(user);
    setIsModalOpen(true);
  };

  // Abrir modal para crear
  const handleCreate = () => {
    setEditingUser(null);
    form.resetFields();
    setIsModalOpen(true);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const columns = [
    {
      title: "Usuario",
      dataIndex: "usr",
      key: "usr",
    },
    {
      title: "Acciones",
      key: "actions",
      render: (text, record) => (
        <>
          <Button type="link" onClick={() => handleEdit(record)}>
            Editar
          </Button>
          <Popconfirm
            title="¿Estás seguro de eliminar este usuario?"
            onConfirm={() => handleDeleteUser(record.usr)}
            okText="Sí"
            cancelText="No"
          >
            <Button type="link" danger>
              Eliminar
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <h1>Gestión de Usuarios</h1>
      <Button type="primary" onClick={handleCreate} style={{ marginBottom: 16 }}>
        Crear Usuario
      </Button>
      <Table columns={columns} dataSource={users} rowKey="usr" />

      <Modal
        title={editingUser ? "Editar Usuario" : "Crear Usuario"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => form.submit()}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSaveUser}
          initialValues={{ usr: "", password: "" }}
        >
          <Form.Item
            name="usr"
            label="Usuario"
            rules={[{ required: true, message: "Por favor, ingrese el usuario" }]}
          >
            <Input placeholder="Nombre de Usuario" disabled={!!editingUser} />
          </Form.Item>
          <Form.Item
            name="password"
            label="Contraseña"
            rules={[{ required: true, message: "Por favor, ingrese una contraseña" }]}
          >
            <Input.Password placeholder="Contraseña" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default UserManager;
